module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop-b34060bbef3452b43377aebd76c1ddcf.jpg";